import { Controller } from "stimulus";
import { isViewport } from "../../assets/utils";

export default class extends Controller {

    async connect() {
        // Admin-Toolbar soll nicht auf Mobilgeräten gerendert werden
        if (isViewport('md')) {
            try {
                const response = await fetch(this.data.get('url') + '?' + this.data.get('params'), {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'include'
                });
                const html = await response.text();
                // Wir kriegen keinen HTTP-Errorcode wenn wir nicht eingeloggt sind.
                if (html.indexOf('loginpage') > -1) {
                    throw false; // not authorized;
                }
                this.element.innerHTML = html;
                return;
            } catch (e) {}
        }
        this.element.remove();
    }
}
